import ModalCreate from './ModalCreate'

export default ModalCreate



// WEBPACK FOOTER //
// ./src/views/Divisions/components/ModalCreate/index.js